import React, {Component} from 'react';
import Team from './Team';

class Round7 extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    

    render() {
        var teams = this.props.teams;

        function getTransform(idx) {
            return `translate(-50%,-50%)`;
        }
        
        return (
            <div className="round7 circle-wrapper">
                {teams.map((team,idx) => (
                    <div key={idx} className="team4" style={{transform:getTransform(idx)}}>
                        <Team 
                            onClick={this.props.onHover}
                            onHover={this.props.onHover}
                            team={team} 
                            round={7}
                            ></Team>
                    </div>
                ))}
            </div>
        );
    }
}

export default Round7;